class AboutJs {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    // VALUEのスマホスライダー
    const topicsSwiper = document.querySelector('.js-about-value-swiper');
    new Swiper(topicsSwiper, {
      slidesPerView: 'auto',
      pagination: {
        el: '.js-about-value-swiper__pagination',
        type: 'progressbar'
      }
    })

    let mm = gsap.matchMedia();

    // フリーランスなのに・・・固定表示（横スクロール）
    const notFreeWrap = '.js-not-free-wrap';
    const notFreeContent = '.js-not-free-text';
    const paginationBar = '.js-not-free-pagination__bar';

    const contentWidth = document.querySelector(notFreeContent).scrollWidth; // 横スクロールに必要な全体の幅を取得

    const delayScroll = 300; // 固定後300px分スクロールしたら横スクロールを開始

    gsap.to(notFreeContent, {
      scrollTrigger: {
        trigger: notFreeWrap,
        start: "top top", // 固定を開始するタイミング
        end: () => `+=${contentWidth + delayScroll}`, // スクロールの終了位置を設定
        scrub: true,
        pin: notFreeWrap, // 固定
        onUpdate: (self) => {
          const progress = self.progress;

          // 横スクロールの制御
          if (progress >= delayScroll / self.end) {
            gsap.to(notFreeContent, {
              x: (contentWidth - window.innerWidth) * (progress - delayScroll / self.end) / (1 - delayScroll / self.end),
              overwrite: 'auto'
            });
          }

          // バーの伸縮の制御
          const adjustedProgress = (progress - delayScroll / self.end) / (1 - delayScroll / self.end);
          if (adjustedProgress > 0) {
            gsap.to(paginationBar, {
              height: `${adjustedProgress * 100}%`, // 横スクロールに応じてバーの高さを調整
              overwrite: 'auto'
            });
          } else {
            gsap.to(paginationBar, {
              height: `0%`, // スクロールが遅れているときはバーを0%にリセット
              overwrite: 'auto'
            });
          }
        },
      }
    })

    const notFreeText = '.js-not-free-content';
    const notFreeTitle = '.js-not-free-title';
    const notFreeBird = '.js-not-free-bird';
    mm.add('(min-width:769px)', () => {
      // フリーランスなのに・・・のテキストサイズの変更
      gsap.to(notFreeTitle, {
        fontSize: '5rem',
        scrollTrigger: {
          trigger: notFreeWrap,
          start: 'top +=200px',
          end: 'top top',
          scrub: 1,
          // toggleActions: 'play none reverse none'
        }
      })
    })
    // フリーランスなのに・・・のopacitycity調整
    gsap.to(notFreeText, {
      opacity: 1,
      scrollTrigger: {
        trigger: notFreeWrap,
        start: 'top top',
        end: 'top -=100px',
        scrub: 1,
        // toggleActions: 'play none reverse none'
      }
    })
    gsap.to(notFreeBird, {
      opacity: 1,
      scrollTrigger: {
        trigger: notFreeWrap,
        start: 'top top',
        end: 'top -=100px',
        scrub: 1,
        // toggleActions: 'play none reverse none'
      }
    })

  }
}
